<h2 mat-dialog-title class="default-title">Edit default layer style</h2>
<mat-dialog-content>
  <form class="style-form" [formGroup]="defaultForm">
    <div *ngIf="!vectorLayer || data.layer.sourceName === 'XYZ'" class="d-flex align-items-center g-1">
      <mat-label>Opacity:</mat-label>
      <mat-slider class="flex-grow-1" [displayWith]="formatPercentLabel" id="layerOpacity" max="100" min="0" step="1">
        <input formControlName="opacity" matSliderThumb />
      </mat-slider>
    </div>

    <div *ngIf="vectorLayer && data.layer.sourceName !== 'XYZ'" class="vector-style">
      <div class="horizontal-container">

        <!-- Default fill color -->
        <div class="color-picker-field">
          <button matIconButton class="color-button"
                  [ngStyle]="{ color: colorFill }"
                  cdkOverlayOrigin #fillOrigin="cdkOverlayOrigin"
                  (click)="editFillColor = true">
            <mat-icon svgIcon="color_fill"></mat-icon>
          </button>
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="fillOrigin"
            [cdkConnectedOverlayOpen]="editFillColor"
            [cdkConnectedOverlayHasBackdrop]="true"
            cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
            (backdropClick)="editFillColor = false"
            (detach)="editFillColor = false">
            <lib-color-swatch-picker
              [triggerHidden]="true"
              [color]="colorFill"
              alphaChannel="forced"
              outputFormat="rgba"
              [presetColors]="usedColors"
              (colorChange)="colorFill = $event"
              (colorApply)="addToUsedColors($event); editFillColor = false"
              (colorCancel)="cancelFillColor(); editFillColor = false" />
          </ng-template>
        </div>

        <!-- Default outline color -->
        <div class="color-picker-field">
          <button matIconButton class="color-button"
                  [ngStyle]="{ color: colorOutline }"
                  cdkOverlayOrigin #outlineOrigin="cdkOverlayOrigin"
                  (click)="editOutlineColor = true">
            <mat-icon svgIcon="border_color"></mat-icon>
          </button>
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="outlineOrigin"
            [cdkConnectedOverlayOpen]="editOutlineColor"
            [cdkConnectedOverlayHasBackdrop]="true"
            cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
            (backdropClick)="editOutlineColor = false"
            (detach)="editOutlineColor = false">
            <lib-color-swatch-picker
              [triggerHidden]="true"
              [color]="colorOutline"
              alphaChannel="forced"
              outputFormat="rgba"
              [presetColors]="usedColors"
              (colorChange)="colorOutline = $event"
              (colorApply)="addToUsedColors($event); editOutlineColor = false"
              (colorCancel)="cancelOutlineColor(); editOutlineColor = false" />
          </ng-template>
        </div>

      </div>
    </div>
  </form>

  <ng-container *ngIf="fields">
    <h2 mat-dialog-title class="gray-title">OR</h2>
    <h2 mat-dialog-title class="default-title">Choose layer style based on attributes</h2>
    <div class="select-attribute">
      <mat-form-field class="mat-form-field-select-field">
        <mat-label>Select field</mat-label>
        <mat-select [(value)]="selectedField" (selectionChange)="updateField()">
          <mat-option *ngFor="let field of fields" [value]="field">{{ field }}</mat-option>
        </mat-select>
      </mat-form-field>
      <button matIconButton *ngIf="selectedField" (click)="removeStyleField(selectedField)">
        <mat-icon class="remove-icon">cancel</mat-icon>
      </button>
    </div>

    <div *ngIf="selectedField && !infoBoxClosed && getAttributesOfField(selectedField).length > 20" class="info-div">
      <button matIconButton class="close-button" (click)="infoBoxClosed = true">
        <mat-icon class="close-icon">close</mat-icon>
      </button>
      <div class="info-text">
        <mat-icon class="info-icon">info_outline</mat-icon>
        The field you have selected contains 20+ values. You can select a field that contains less to easily categorize the symbols.
      </div>
    </div>

    <div>
      <div *ngFor="let style of additionalStyles" class="select-attribute">
        <mat-form-field appearance="fill" class="mat-form-field-select">
          <mat-label>Select attribute</mat-label>
          <mat-select [disabled]="!selectedField" [(value)]="style.filter[2]">
            <mat-option
              *ngFor="let value of getAttributesOfField(selectedField)"
              [value]="value"
              [disabled]="isAttributeSelected(value)">
              {{ value }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="horizontal-container-attribute">

          <!-- Per-attribute fill color -->
          <div class="color-picker-field">
            <button matIconButton class="color-button"
                    [ngStyle]="{ color: style.paint.fillColor }"
                    cdkOverlayOrigin #styleFillOrigin="cdkOverlayOrigin"
                    (click)="style.editFillColor = true"
                    [disabled]="!selectedField">
              <mat-icon svgIcon="color_fill"></mat-icon>
            </button>
            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="styleFillOrigin"
              [cdkConnectedOverlayOpen]="style.editFillColor"
              [cdkConnectedOverlayHasBackdrop]="true"
              cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
              (backdropClick)="style.editFillColor = false"
              (detach)="style.editFillColor = false">
              <lib-color-swatch-picker
                [triggerHidden]="true"
                [color]="style.paint.fillColor"
                alphaChannel="forced"
                outputFormat="rgba"
                [presetColors]="usedColors"
                (colorChange)="style.paint.fillColor = $event"
                (colorApply)="addToUsedColors($event); style.editFillColor = false"
                (colorCancel)="style.paint.fillColor = defaultOutlineColor; style.editFillColor = false" />
            </ng-template>
          </div>

          <!-- Per-attribute outline color -->
          <div class="color-picker-field">
            <button matIconButton class="color-button"
                    [ngStyle]="{ color: style.paint.outlineColor }"
                    cdkOverlayOrigin #styleOutlineOrigin="cdkOverlayOrigin"
                    (click)="style.editOutlineColor = true"
                    [disabled]="!selectedField">
              <mat-icon svgIcon="border_color"></mat-icon>
            </button>
            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="styleOutlineOrigin"
              [cdkConnectedOverlayOpen]="style.editOutlineColor"
              [cdkConnectedOverlayHasBackdrop]="true"
              cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
              (backdropClick)="style.editOutlineColor = false"
              (detach)="style.editOutlineColor = false">
              <lib-color-swatch-picker
                [triggerHidden]="true"
                [color]="style.paint.outlineColor"
                alphaChannel="forced"
                outputFormat="rgba"
                [presetColors]="usedColors"
                (colorChange)="style.paint.outlineColor = $event"
                (colorApply)="addToUsedColors($event); style.editOutlineColor = false"
                (colorCancel)="style.paint.outlineColor = defaultOutlineColor; style.editOutlineColor = false" />
            </ng-template>
          </div>

          <button matIconButton *ngIf="style.filter[2]" (click)="removeStyleAttribute(style)">
            <mat-icon class="remove-icon">cancel</mat-icon>
          </button>
        </div>
      </div>

      <button
        matButton
        (click)="addAdditionalStyle(null)"
        [disabled]="!selectedField || getAttributesOfField(selectedField).length <= additionalStyles.length">
        + Add additional Style
      </button>
    </div>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions>
  <button matButton="elevated" (click)="close()" mat-dialog-close>Cancel</button>
  <button
    matButton="filled" color="primary"
    matTooltip="Fill all fields first"
    [matTooltipDisabled]="isValidForm()"
    [mat-dialog-close]="true"
    [disabled]="!isValidForm()"
    (click)="send()">
    Save
  </button>
</mat-dialog-actions>